import SportInfo from "./SportInfo";
export default SportInfo;
